import * as z from 'zod';

const OutcomeSchema = z.enum(['W', 'L', 'D']);

export default OutcomeSchema;
